/**
 * Asynchronously loads the component for PrintSelectStagesModal
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
